/**
 * Plan `features` from the API mix two kinds of entries:
 *  - limit lines written for people, e.g. "Up to 2 users", "Unlimited branches"
 *    (the backend builds these from the plan's max_* fields — never rebuild them)
 *  - feature keys, e.g. "user_management", which we turn into labels
 * Anything containing a space is already readable text and is shown as-is.
 */
const isReadableText = (entry: string) => entry.includes(" ");

// "user_management" -> "User Management" (matches how plans were labelled before)
export const featureLabel = (entry: string): string =>
    isReadableText(entry)
        ? entry
        : entry
              .split("_")
              .filter(Boolean)
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ");

export const splitPlanFeatures = (features: unknown) => {
    const entries = Array.isArray(features)
        ? features.filter((f): f is string => typeof f === "string" && f.trim() !== "")
        : [];
    return {
        limits: entries.filter(isReadableText),
        features: entries.filter((f) => !isReadableText(f)).map(featureLabel),
    };
};
